import React, { useState } from "react";
import { ContentPanel } from "components/displays";
import { Table } from "@redriver/cinnamon";
import { InfoModalWrapper } from "components/modals/";
import NewCustomerSignatory from "features/Companies/Customers/Signatories/NewCustomerSignatory";
import AuthorisedCustomerSignatoryTable from "features/Companies/Customers/Signatories/AuthorisedCustomerSignatoryTable";
import ArchivedCustomerSignatoryTable from "features/Companies/Customers/Signatories/ArchivedCustomerSignatoryTable";

const CustomerSignatories = ({ clientId }) => {
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  return (
    <ContentPanel
      title="Signatories"
      wrapperCssClass="outline-grid signatories-container"
      headerCssClass="defaults-page-title"
    >
      <div className="padded">
        <ContentPanel
          title="Authorised Signatories"
          wrapperCssClass="outline-grid"
          headerCssClass="defaults-page-title"
          headerContent={
            process.env.TRADE_AS_IPS && (
              <NewCustomerSignatory
                onSubmitted={() => setLastUpdated(Date.now())}
                clientId={clientId}
              />
            )
          }
        >
          <div className="padded">
            <AuthorisedCustomerSignatoryTable
              forceUpdate={() => setLastUpdated(Date.now())}
              onAdded={lastUpdated}
              clientId={clientId}
            />
          </div>
        </ContentPanel>
        {process.env.TRADE_AS_IPS && (
          <React.Fragment>
            <div className="historic-btn-container">
              <InfoModalWrapper title="Historic">
                {" "}
                Not implemented.{" "}
              </InfoModalWrapper>
            </div>
            <ContentPanel
              title="Historic Signatories"
              wrapperCssClass="outline-grid"
              headerCssClass="defaults-page-title"
            >
              <div className="padded">
                <ArchivedCustomerSignatoryTable
                  forceUpdate={() => setLastUpdated(Date.now())}
                  onAdded={lastUpdated}
                  clientId={clientId}
                />
              </div>
            </ContentPanel>
          </React.Fragment>
        )}
      </div>
    </ContentPanel>
  );
};

export default CustomerSignatories;
